<template>
  <SignUpPin
    :pin="pin"
    :email="email"
    :disable="sendingSignUpPin"
    :loading="sendingSignUpPin"
    :lock="failureDisableInput"
    :error-message="failureReasonError"
    :errors="$v"
    @update:pin="updatePin"
    @submit:pin="submit"
    @resend:email="resendEmail"
    @back="$router.push({ name: $RouteNames.signUp })"
  />
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { getNumberWithOrdinal } from '../../utils/numbers';
import validations from './validations';

export default {
  name: 'SignUpPinWidget',
  props: {
    token: String,
    tokenType: String
  },
  validations,
  computed: {
    ...mapState({
      pin: (state) => state.signUp.pin,
      email: (state) => state.signUp.email,
      pinAllowedAttempts: (state) => state.signUp.pinAllowedAttempts,
      pinAttempts: (state) => state.signUp.pinAttempts,
      sendingSignUpPin: (state) => state.signUp.sendingSignUpPin,
      signUpPinFailureReason: (state) => state.signUp.signUpPinFailureReason
    }),
    failureDisableInput() {
      return (
        this.signUpPinFailureReason ===
          this.$Constants.PIN_ERROR_STATUSES.tokenExpired ||
        this.signUpPinFailureReason ===
          this.$Constants.PIN_ERROR_STATUSES.maxAttemptReached
      );
    },
    failureReasonError() {
      switch (this.signUpPinFailureReason) {
        case this.$Constants.PIN_ERROR_STATUSES.tokenExpired:
          return 'Your pin has expired, you must reset and enter a new pin to continue';
        case this.$Constants.PIN_ERROR_STATUSES.maxAttemptReached:
          return `You have failed ${this.pinAllowedAttempts} times and your account has been locked. Resend your PIN below or contact us on novatedlease@fleetchoice.com.au for further assistance.`;
        case this.$Constants.PIN_ERROR_STATUSES.tokenDidNotMatch:
          let attempts = getNumberWithOrdinal(this.pinAttempts + 1);
          return `The PIN is incorrect. You have ${this.pinAllowedAttempts} attempts and this is your ${attempts} attempt.`;
        default:
          return undefined;
      }
    }
  },
  methods: {
    ...mapMutations('signUp', ['setPin']),
    ...mapActions('signUp', ['validateEmail', 'resendValidation']),
    async updatePin(value) {
      await this.setPin(value);
      if (value.length === this.$Constants.PIN_LENGTH) {
        await this.submit();
      }
    },
    async resendEmail() {
      try {
        const response = await this.resendValidation({
          oldToken: this.token,
          oldTokenType: this.tokenType
        });
        if (response) {
          window.location = response;
        }
      } catch (err) {}
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      try {
        await this.validateEmail({
          token: this.token,
          tokenType: this.tokenType
        });
        const routeName = this.$auth.user
          ? this.$RouteNames.dashboard
          : this.$RouteNames.login;
        this.$router.push({ name: routeName });
      } catch (err) {}
    }
  },
  components: {
    SignUpPin: () => import('../../components/page/sign-up-pin')
  }
};
</script>
